var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Online Payments"}},[_c('payment-order-filter',{on:{"filtersUpdated":_vm.filtersChangeHandler}}),_c('payment-order-list',{attrs:{"filters":_vm.filters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }